import { MenuListItem } from "@teamscheme/header-elements";
import React, { HTMLAttributes } from "react";
import styled from "styled-components";
import Header, { HeaderVariant } from "./Header";
import {
  useAuthHeaderElements,
  createFaqHeaderProps,
  createAboutHeaderProps,
  useStaticBecomeMemberMenuItem,
} from "./HeaderObjects";

const StaticHeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.nafColor.signature.white};
  width: 100%;
  z-index: 2;
`;

export default function StaticHeader(props: HTMLAttributes<HTMLDivElement>) {
  const authHeaderProps = useAuthHeaderElements();
  const faqProps = createFaqHeaderProps();
  const aboutProps = createAboutHeaderProps();
  const becomeMember = useStaticBecomeMemberMenuItem();
  const elements = [...authHeaderProps, becomeMember, aboutProps, faqProps];

  return (
    <StaticHeaderWrapper {...props}>
      <Header
        variant={HeaderVariant.Static}
        elements={elements.filter((e): e is MenuListItem => !!e)}
      />
    </StaticHeaderWrapper>
  );
}
